const animationCss = `
    .animation-hidden {
        visibility: hidden!important;
        opacity: 0!important;
    }

    @keyframes bg-marquee-horizontal {
        0% {
          background-position-x: 0;
        }
      
        100% {
          background-position-x: -99999px;
        }
      }
  
      @keyframes bg-marquee-vertical {
        0% {
          background-position-y: 0;
        }
      
        100% {
          background-position-y: -99999px;
        }
    }
`;

export { animationCss };
